/* ============
 * Send invoice
 * ============
 *
 * Send invoice email to client.
 */

import Vue from 'vue';
import invoiceMessageTransformer from '../../transformers/invoiceMessage';

export default (id, previewParams) => (
  new Promise((resolve, reject) => {
    Vue.$http.post(`tripletex/${id}/send`, invoiceMessageTransformer.send(previewParams))
    .then(() => {
      resolve();
    })
    .catch(() => {
      reject();
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/invoice/sendTripletex.js